import createSvgIcon from '../Utils/CreateSvgIcon';

export const Datasheet = createSvgIcon(
  <>
    <path
      d="M19 7.414V21H5V3h9.586L19 7.414Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="m8 14 3.796 3L16 11" fill="transparent" stroke="currentColor" strokeWidth="2" />
    <path d="M14 8h5l-5-5v5Z" />
  </>,
  'Datasheet',
);
